import {createFileRoute, notFound} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getProductById} from "~/domainModels/ottokart/products";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/products/$productId/$variantId")({
    loader: async ({context, params}) => {
        const {productId: productIdRaw, variantId: variantIdRaw} = params;
        const productIdResult = uuidZodValidator.safeParse(productIdRaw);
        const variantIdResult = uuidZodValidator.safeParse(variantIdRaw);
        if (!productIdResult.success || !variantIdResult.success) {
            throw new Error("Invalid product or variant ID");
        }
        const productId = productIdResult.data;
        const variantId = variantIdResult.data;

        const productResult = await getProductById({
            intellsysBaseUrl: context.intellsysBaseUrl,
            workspaceId: context.workspace.id,
            accessToken: context.authenticationStatus.accessToken,
            productId: productId,
        });
        if (productResult.success !== true) {
            throw productResult.error;
        }
        const product = productResult.data;
        const variant = product.variants.find((v) => v.id === variantId);
        if (variant === undefined) {
            throw notFound();
        }

        return {
            variant,
            productWithVariants: product,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
